import { CgMenuGridO } from "react-icons/cg";
import Fade from "react-reveal/Fade";
import { Link } from "react-scroll";

const Menu = () => {
	const resumeLink =
		"https://drive.google.com/file/d/1CgUXoVDeoqFvSy9oBqTsenfqRoy74qfF/view?usp=sharing";
	return (
		<nav className="navbar navbar-expand-md navbar-dark sticky-top">
			<Fade top>
				<div className="container">
					<Link
						style={{ cursor: "pointer" }}
						className="navbar-brand logo ml-2"
						to="home"
						smooth={true}
						duration={1000}
					>
						<span className="angle">&lt;</span>
						<span className="title">TAMIM </span>
						<span className="angle">/&gt;</span>
					</Link>
					<button
						style={{ cursor: "pointer" }}
						className="navbar-toggler"
						type="button"
						data-toggle="collapse"
						data-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span>
							<CgMenuGridO
								className="text-white"
								style={{ fontSize: "1.5em" }}
							/>
						</span>
					</button>
					<div
						className="collapse navbar-collapse text-center"
						id="navbarSupportedContent"
					>
						<ul className="navbar-nav ml-auto">
							<li className="nav-item ml-3">
								<Link
									style={{ cursor: "pointer" }}
									className="nav-link text-white font-weight-bold"
									to="home"
									smooth={true}
									duration={1000}
									spy={true}
									activeClass="active"
								>
									Home
								</Link>
							</li>
							<li className="nav-item ml-3">
								<Link
									style={{ cursor: "pointer" }}
									className="nav-link text-white font-weight-bold"
									to="projects"
									smooth={true}
									duration={1000}
									spy={true}
									activeClass="active"
								>
									Projects
								</Link>
							</li>
							<li className="nav-item ml-3">
								<Link
									style={{ cursor: "pointer" }}
									className="nav-link text-white font-weight-bold"
									to="blogs"
									smooth={true}
									duration={1000}
									spy={true}
									activeClass="active"
								>
									Blogs
								</Link>
							</li>
							<li className="nav-item ml-3 mr-3 text-white resume">
								<a
									className="nav-link btn btn-outline-danger text-white font-weight-bold"
									href={resumeLink}
									target="_blank"
									rel="noopener noreferrer"
								>
									Resume
								</a>
							</li>
						</ul>
					</div>
				</div>
			</Fade>
		</nav>
	);
};

export default Menu;
